module.exports = __webpack_public_path__ + "img/gloden-visa-slide.7906f12e.png";